import { render, staticRenderFns } from "./RailList.vue?vue&type=template&id=4d38563d&scoped=true"
import script from "./RailList.vue?vue&type=script&lang=js"
export * from "./RailList.vue?vue&type=script&lang=js"
import style0 from "./RailList.vue?vue&type=style&index=0&id=4d38563d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38563d",
  null
  
)

export default component.exports